import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { abort_drawing_edge_on_face, start_drawing_edge_on_face } from '../../scene';
import { disabled } from '../../state/operations/carve';
import { shift_pressed } from '../../keypress';
import carve_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/carve.svg';
import { img } from '@phi/components';
import CarveTooltip from './CarveTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const CarveIcon = carve_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Carve model';
        }
    },

    methods: {
        onClick() {
            if (disabled.value)
                return;
            else if (this.state.carving)
                abort_drawing_edge_on_face();
            else
                start_drawing_edge_on_face(true, shift_pressed());
        },

        onLongClick() {
            if (disabled.value)
                return;
            else if (this.state.carving)
                abort_drawing_edge_on_face();
            else
                start_drawing_edge_on_face(true, true);
        },
    },

    render() {
        return h(BarButton, {
            disabled: disabled.value,
            selected: this.state.tut_stage === 2,
            active: this.state.carving,
            id: 'carve-button',
            wrapperId: 'carve-wrapper',
            tippy: 'bottom',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
            help: 'carve',
        }, {
            label: () => 'Carve',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(carve_svg, this.alt),
            tooltip: CarveTooltip,
        });
    },
});
